module.exports = __webpack_public_path__ + "media/images/lp-typing-2f951f655d1292b7e65c4433821dda49.jpg";